export const ORDER_LIST = 'user/orderList';